import {useQuery} from 'react-query';

import {getBasket} from './getBasket';
import {BasketResponse} from './types';

const useGetBasket = () => {
  const {data, isLoading, refetch} = useQuery<BasketResponse[]>(
    ['get-basket'],
    getBasket,
  );
  return {data, isLoading, refetch};
};

export default useGetBasket;
